import React, { useCallback } from "react"
import styled from "styled-components"
import { black, lightGrey, white } from "./colors"

const ButtonActiveBackgroundColor = "#e5e7eb"

const IconWrapper = styled.div<{ $noBackground?: boolean }>`
  background: ${(props) => (props.$noBackground ? "none" : lightGrey)};
  border-radius: 0.8rem;
  width: 100%;
  height: 100%;

  & > svg {
    margin: ${(props) => (props.$noBackground ? 0 : 0.6)}rem;
  }
`

const IconText = styled.span`
  position: absolute;
  height: 1rem;
  width: 2rem;
  text-align: center;
  left: calc(50% - 0.9rem);
  top: calc(50% - 0.9rem);
`

const Button = styled.button<{
  $selected?: boolean
  $disabled?: boolean
  $noBackground: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${(props) => (props.$noBackground ? white : black)};
  border: none;
  cursor: pointer;
  font-size: 1rem;
  font-family: inherit;
  font-weight: bold;
  position: relative;
  border-radius: 22px;
  border-width: 2px;
  border-style: solid;
  border-color: ${(props) =>
    props.$selected ? ButtonActiveBackgroundColor : "transparent"};
  padding: 6px;
  opacity: ${(props) => (props.$disabled ? 0.35 : 1)};
  background-color: transparent;

  box-sizing: border-box;
  width: 72px;
  height: 72px;

  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transform: scale(1);

  &:active {
    ${IconWrapper} {
      transform: scale(${(props) => (props.$disabled ? 1 : 0.8)});
      transition: transform 0.2s;
    }
  }
`
export const EditorButtonSeparator = styled.div`
  width: 0.3rem;
  height: 3.2rem;
  background-color: ${white};
  margin: 0 0.3rem;
  border-radius: 0.1rem;
`

export const EditorButton: React.FC<{
  icon?: React.ReactNode | null
  text?: string
  selected?: boolean
  disabled?: boolean
  noBackground?: boolean
  onClick?: () => void
}> = ({
  icon = null,
  text,
  onClick = () => {},
  disabled = false,
  noBackground = false,
  selected = false,
}) => {
  const noOp = useCallback(() => {}, [])
  return (
    <Button
      $disabled={disabled}
      $selected={selected}
      onClick={disabled ? noOp : onClick}
      $noBackground={noBackground}
    >
      {text && <IconText>{text}</IconText>}
      {!!icon && <IconWrapper $noBackground={noBackground}>{icon}</IconWrapper>}
    </Button>
  )
}
//
